/**
 * O código das páginas da clínica, carregado de antemão quando a mesa abre: trocar de página
 * na barra lateral não espera o download (e não pisca a tela de carregando).
 */
const loaders: (() => Promise<unknown>)[] = [];
let started = false;

export function registerClinicPage(load: () => Promise<unknown>) {
  loaders.push(load);
}

export function preloadClinicPages() {
  if (started || loaders.length === 0) return;
  started = true;
  const run = () => {
    // Um por vez, sem disputar a rede com a página aberta.
    void loaders.reduce<Promise<unknown>>(
      (chain, load) => chain.then(() => load().catch(() => undefined)),
      Promise.resolve(),
    );
  };
  const idle = (window as Window & { requestIdleCallback?: (fn: () => void) => number })
    .requestIdleCallback;
  if (idle) idle(run);
  else window.setTimeout(run, 1200);
}
